import { CaretDown, Plus } from "@phosphor-icons/react";
import { Avatar, Button, PopupSelect, Badge } from "../components";
import Section from "../components/Section";
import { useState } from "react";
const pillTypeOptions = [
	{ label: "pill-color", value: "pill-color" },
	{ label: "outline", value: "outline" },
	{ label: "badge-color", value: "badge-color" },
	{ label: "badge-modern", value: "badge-modern" }
];
const AvatarSection = () => {
	const [pillType, setPillType] = useState<"pill-color" | "outline" | "badge-color" | "badge-modern">("pill-color");
	const handleSelect = (item: any) => {
		setPillType(item.value);
	};
	return (
		<Section title={"# Badges"}>
			<div className="d-flex justify-content-end">
				<PopupSelect
					target={
						<Button
							label={pillType}
							variant={"secondary"}
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
							size="small"
						/>
					}
					value={{ label: pillType, value: pillType }}
					setValue={handleSelect}
					selectOptions={pillTypeOptions}
					popupParentClass="mt-1"
					position="bottom"
				/>
			</div>
			<div className="d-flex gap2">
				<div className="d-flex flex-direction-column gap1 mr-3">
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="grey" icon={false}>
							Label
						</Badge>
						<Badge size="sm" type={pillType} color="grey" icon={false}>
							Label
						</Badge>
						<Badge size="md" type={pillType} color="grey" icon={false}>
							Label
						</Badge>
						<Badge size="lg" type={pillType} color="grey" icon={false}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="brand" icon={false}>
							Label
						</Badge>
						<Badge size="sm" type={pillType} color="brand" icon={false}>
							Label
						</Badge>
						<Badge size="md" type={pillType} color="brand" icon={false}>
							Label
						</Badge>
						<Badge size="lg" type={pillType} color="brand" icon={false}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="error" icon={false}>
							Label
						</Badge>
						<Badge size="sm" type={pillType} color="error" icon={false}>
							Label
						</Badge>
						<Badge size="md" type={pillType} color="error" icon={false}>
							Label
						</Badge>
						<Badge size="lg" type={pillType} color="error" icon={false}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="warning" icon={false}>
							Label
						</Badge>
						<Badge size="sm" type={pillType} color="warning" icon={false}>
							Label
						</Badge>
						<Badge size="md" type={pillType} color="warning" icon={false}>
							Label
						</Badge>
						<Badge size="lg" type={pillType} color="warning" icon={false}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="success" icon={false}>
							Label
						</Badge>
						<Badge size="sm" type={pillType} color="success" icon={false}>
							Label
						</Badge>
						<Badge size="md" type={pillType} color="success" icon={false}>
							Label
						</Badge>
						<Badge size="lg" type={pillType} color="success" icon={false}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="grey_blue" icon={false}>
							Label
						</Badge>
						<Badge size="sm" type={pillType} color="grey_blue" icon={false}>
							Label
						</Badge>
						<Badge size="md" type={pillType} color="grey_blue" icon={false}>
							Label
						</Badge>
						<Badge size="lg" type={pillType} color="grey_blue" icon={false}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="blue_light" icon={false}>
							Label
						</Badge>
						<Badge size="sm" type={pillType} color="blue_light" icon={false}>
							Label
						</Badge>
						<Badge size="md" type={pillType} color="blue_light" icon={false}>
							Label
						</Badge>
						<Badge size="lg" type={pillType} color="blue_light" icon={false}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="blue" icon={false}>
							Label
						</Badge>
						<Badge size="sm" type={pillType} color="blue" icon={false}>
							Label
						</Badge>
						<Badge size="md" type={pillType} color="blue" icon={false}>
							Label
						</Badge>
						<Badge size="lg" type={pillType} color="blue" icon={false}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="purple" icon={false}>
							Label
						</Badge>
						<Badge size="sm" type={pillType} color="purple" icon={false}>
							Label
						</Badge>
						<Badge size="md" type={pillType} color="purple" icon={false}>
							Label
						</Badge>
						<Badge size="lg" type={pillType} color="purple" icon={false}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="indigo" icon={false}>
							Label
						</Badge>
						<Badge size="sm" type={pillType} color="indigo" icon={false}>
							Label
						</Badge>
						<Badge size="md" type={pillType} color="indigo" icon={false}>
							Label
						</Badge>
						<Badge size="lg" type={pillType} color="indigo" icon={false}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="pink" icon={false}>
							Label
						</Badge>
						<Badge size="sm" type={pillType} color="pink" icon={false}>
							Label
						</Badge>
						<Badge size="md" type={pillType} color="pink" icon={false}>
							Label
						</Badge>
						<Badge size="lg" type={pillType} color="pink" icon={false}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="orange" icon={false}>
							Label
						</Badge>
						<Badge size="sm" type={pillType} color="orange" icon={false}>
							Label
						</Badge>
						<Badge size="md" type={pillType} color="orange" icon={false}>
							Label
						</Badge>
						<Badge size="lg" type={pillType} color="orange" icon={false}>
							Label
						</Badge>
					</div>
				</div>
				<div className="d-flex flex-direction-column gap1">
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="grey" icon={"dot"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="brand" icon={"dot"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="error" icon={"dot"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="warning" icon={"dot"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="success" icon={"dot"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="grey_blue" icon={"dot"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="blue_light" icon={"dot"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="blue" icon={"dot"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="purple" icon={"dot"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="indigo" icon={"dot"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="pink" icon={"dot"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="orange" icon={"dot"}>
							Label
						</Badge>
					</div>
				</div>
				<div className="d-flex flex-direction-column gap1">
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="grey" icon={"x-close"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="brand" icon={"x-close"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="error" icon={"x-close"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="warning" icon={"x-close"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="success" icon={"x-close"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="grey_blue" icon={"x-close"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="blue_light" icon={"x-close"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="blue" icon={"x-close"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="purple" icon={"x-close"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="indigo" icon={"x-close"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="pink" icon={"x-close"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="orange" icon={"x-close"} iconPosition="right">
							Label
						</Badge>
					</div>
				</div>
				<div className="d-flex flex-direction-column gap1">
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="grey" icon={"trailing"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="brand" icon={"trailing"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="error" icon={"trailing"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="warning" icon={"trailing"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="success" icon={"trailing"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="grey_blue" icon={"trailing"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="blue_light" icon={"trailing"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="blue" icon={"trailing"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="purple" icon={"trailing"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="indigo" icon={"trailing"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="pink" icon={"trailing"} iconPosition="right">
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="orange" icon={"trailing"} iconPosition="right">
							Label
						</Badge>
					</div>
				</div>
				<div className="d-flex flex-direction-column gap1">
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="grey" icon={"leading"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="brand" icon={"leading"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="error" icon={"leading"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="warning" icon={"leading"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="success" icon={"leading"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="grey_blue" icon={"leading"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="blue_light" icon={"leading"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="blue" icon={"leading"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="purple" icon={"leading"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="indigo" icon={"leading"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="pink" icon={"leading"}>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="md" type={pillType} color="orange" icon={"leading"}>
							Label
						</Badge>
					</div>
				</div>
				<div className="d-flex flex-direction-column gap1">
					<div className="d-flex align-items-center gap2">
						<Badge
							size="xs"
							type={pillType}
							color="grey"
							icon={"avatar"}
							iconComponent={
								<Avatar
									size="custom"
									src="https://lh3.googleusercontent.com/ogw/AF2bZyiblb3IWMhXzI86zV3P3aEr2qfPacKWrGT_PB1bDxCR=s64-c-mo"
									src_text={""}
									id={""}
									image_hash={""}
									mime_type={""}
									height="0.75rem"
									width="0.75rem"
								/>
							}
						>
							Label
						</Badge>
					</div>

					<div className="d-flex align-items-center gap2">
						<Badge
							size="sm"
							type={pillType}
							color="brand"
							icon={"avatar"}
							iconComponent={
								<Avatar
									size="custom"
									src="https://lh3.googleusercontent.com/ogw/AF2bZyiblb3IWMhXzI86zV3P3aEr2qfPacKWrGT_PB1bDxCR=s64-c-mo"
									src_text={""}
									id={""}
									image_hash={""}
									mime_type={""}
									height="1rem"
									width="1rem"
								/>
							}
						>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge
							size="sm"
							type={pillType}
							color="error"
							icon={"avatar"}
							iconComponent={
								<Avatar
									size="custom"
									src="https://lh3.googleusercontent.com/ogw/AF2bZyiblb3IWMhXzI86zV3P3aEr2qfPacKWrGT_PB1bDxCR=s64-c-mo"
									src_text={""}
									id={""}
									image_hash={""}
									mime_type={""}
									height="1rem"
									width="1rem"
								/>
							}
						>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge
							size="md"
							type={pillType}
							color="warning"
							icon={"avatar"}
							iconComponent={
								<Avatar
									size="custom"
									src="https://lh3.googleusercontent.com/ogw/AF2bZyiblb3IWMhXzI86zV3P3aEr2qfPacKWrGT_PB1bDxCR=s64-c-mo"
									src_text={""}
									id={""}
									image_hash={""}
									mime_type={""}
									height="1rem"
									width="1rem"
								/>
							}
						>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge
							size="lg"
							type={pillType}
							color="success"
							icon={"avatar"}
							iconComponent={
								<Avatar
									size="custom"
									src="https://lh3.googleusercontent.com/ogw/AF2bZyiblb3IWMhXzI86zV3P3aEr2qfPacKWrGT_PB1bDxCR=s64-c-mo"
									src_text={""}
									id={""}
									image_hash={""}
									mime_type={""}
									height="1.25rem"
									width="1.25rem"
								/>
							}
						>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge
							size="md"
							type={pillType}
							color="grey_blue"
							icon={"avatar"}
							iconComponent={
								<Avatar
									size="custom"
									src="https://lh3.googleusercontent.com/ogw/AF2bZyiblb3IWMhXzI86zV3P3aEr2qfPacKWrGT_PB1bDxCR=s64-c-mo"
									src_text={""}
									id={""}
									image_hash={""}
									mime_type={""}
									height="1rem"
									width="1rem"
								/>
							}
						>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge
							size="md"
							type={pillType}
							color="blue_light"
							icon={"avatar"}
							iconComponent={
								<Avatar
									size="custom"
									src="https://lh3.googleusercontent.com/ogw/AF2bZyiblb3IWMhXzI86zV3P3aEr2qfPacKWrGT_PB1bDxCR=s64-c-mo"
									src_text={""}
									id={""}
									image_hash={""}
									mime_type={""}
									height="1rem"
									width="1rem"
								/>
							}
						>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge
							size="md"
							type={pillType}
							color="blue"
							icon={"avatar"}
							iconComponent={
								<Avatar
									size="custom"
									src="https://lh3.googleusercontent.com/ogw/AF2bZyiblb3IWMhXzI86zV3P3aEr2qfPacKWrGT_PB1bDxCR=s64-c-mo"
									src_text={""}
									id={""}
									image_hash={""}
									mime_type={""}
									height="1rem"
									width="1rem"
								/>
							}
						>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge
							size="md"
							type={pillType}
							color="purple"
							icon={"avatar"}
							iconComponent={
								<Avatar
									size="custom"
									src="https://lh3.googleusercontent.com/ogw/AF2bZyiblb3IWMhXzI86zV3P3aEr2qfPacKWrGT_PB1bDxCR=s64-c-mo"
									src_text={""}
									id={""}
									image_hash={""}
									mime_type={""}
									height="1rem"
									width="1rem"
								/>
							}
						>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge
							size="md"
							type={pillType}
							color="indigo"
							icon={"avatar"}
							iconComponent={
								<Avatar
									size="custom"
									src="https://lh3.googleusercontent.com/ogw/AF2bZyiblb3IWMhXzI86zV3P3aEr2qfPacKWrGT_PB1bDxCR=s64-c-mo"
									src_text={""}
									id={""}
									image_hash={""}
									mime_type={""}
									height="1rem"
									width="1rem"
								/>
							}
						>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge
							size="md"
							type={pillType}
							color="pink"
							icon={"avatar"}
							iconComponent={
								<Avatar
									size="custom"
									src="https://lh3.googleusercontent.com/ogw/AF2bZyiblb3IWMhXzI86zV3P3aEr2qfPacKWrGT_PB1bDxCR=s64-c-mo"
									src_text={""}
									id={""}
									image_hash={""}
									mime_type={""}
									height="1rem"
									width="1rem"
								/>
							}
						>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge
							size="md"
							type={pillType}
							color="orange"
							icon={"avatar"}
							iconComponent={
								<Avatar
									size="custom"
									src="https://lh3.googleusercontent.com/ogw/AF2bZyiblb3IWMhXzI86zV3P3aEr2qfPacKWrGT_PB1bDxCR=s64-c-mo"
									src_text={""}
									id={""}
									image_hash={""}
									mime_type={""}
									height="1rem"
									width="1rem"
								/>
							}
						>
							Label
						</Badge>
					</div>
				</div>
				<div className="d-flex flex-direction-column gap1">
					<div className="d-flex align-items-center gap2">
						<Badge style={{ paddingLeft: "3px" }} size="xs" type={pillType} color="grey" icon={false}>
							<Avatar
								size="custom"
								src="https://dev.connect.payzli.com/api/v1/Auth/get_file?hash=5f5b174c8ab6c732caffd82dfd54e72c50b5c686&mime_type=image/png"
								src_text={""}
								id={""}
								image_hash={""}
								mime_type={""}
								height="0.75rem"
								width="0.75rem"
							/>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge style={{ paddingLeft: "3px" }} size="sm" type={pillType} color="brand" icon={false}>
							<Avatar
								size="custom"
								src="https://dev.connect.payzli.com/api/v1/Auth/get_file?hash=5f5b174c8ab6c732caffd82dfd54e72c50b5c686&mime_type=image/png"
								src_text={""}
								id={""}
								image_hash={""}
								mime_type={""}
								height="0.85rem"
								width="0.85rem"
							/>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge style={{ paddingLeft: "3px" }} size="md" type={pillType} color="error" icon={false}>
							<Avatar
								size="custom"
								src="https://dev.connect.payzli.com/api/v1/Auth/get_file?hash=5f5b174c8ab6c732caffd82dfd54e72c50b5c686&mime_type=image/png"
								src_text={""}
								id={""}
								image_hash={""}
								mime_type={""}
								height="1rem"
								width="1rem"
							/>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge style={{ paddingLeft: "3px" }} size="lg" type={pillType} color="warning" icon={false}>
							<Avatar
								size="custom"
								src="https://dev.connect.payzli.com/api/v1/Auth/get_file?hash=5f5b174c8ab6c732caffd82dfd54e72c50b5c686&mime_type=image/png"
								src_text={""}
								id={""}
								image_hash={""}
								mime_type={""}
								height="1.25rem"
								width="1.25rem"
							/>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge style={{ paddingLeft: "3px" }} size="md" type={pillType} color="success" icon={false}>
							<Avatar
								size="custom"
								src="https://dev.connect.payzli.com/api/v1/Auth/get_file?hash=5f5b174c8ab6c732caffd82dfd54e72c50b5c686&mime_type=image/png"
								src_text={""}
								id={""}
								image_hash={""}
								mime_type={""}
								height="1rem"
								width="1rem"
							/>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge style={{ paddingLeft: "3px" }} size="md" type={pillType} color="grey_blue" icon={false}>
							<Avatar
								size="custom"
								src="https://dev.connect.payzli.com/api/v1/Auth/get_file?hash=5f5b174c8ab6c732caffd82dfd54e72c50b5c686&mime_type=image/png"
								src_text={""}
								id={""}
								image_hash={""}
								mime_type={""}
								height="1rem"
								width="1rem"
							/>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge style={{ paddingLeft: "3px" }} size="md" type={pillType} color="blue_light" icon={false}>
							<Avatar
								size="custom"
								src="https://dev.connect.payzli.com/api/v1/Auth/get_file?hash=5f5b174c8ab6c732caffd82dfd54e72c50b5c686&mime_type=image/png"
								src_text={""}
								id={""}
								image_hash={""}
								mime_type={""}
								height="1rem"
								width="1rem"
							/>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge style={{ paddingLeft: "3px" }} size="md" type={pillType} color="blue" icon={false}>
							<Avatar
								size="custom"
								src="https://dev.connect.payzli.com/api/v1/Auth/get_file?hash=5f5b174c8ab6c732caffd82dfd54e72c50b5c686&mime_type=image/png"
								src_text={""}
								id={""}
								image_hash={""}
								mime_type={""}
								height="1rem"
								width="1rem"
							/>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge style={{ paddingLeft: "3px" }} size="md" type={pillType} color="purple" icon={false}>
							<Avatar
								size="custom"
								src="https://dev.connect.payzli.com/api/v1/Auth/get_file?hash=5f5b174c8ab6c732caffd82dfd54e72c50b5c686&mime_type=image/png"
								src_text={""}
								id={""}
								image_hash={""}
								mime_type={""}
								height="1rem"
								width="1rem"
							/>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge style={{ paddingLeft: "3px" }} size="md" type={pillType} color="indigo" icon={false}>
							<Avatar
								size="custom"
								src="https://dev.connect.payzli.com/api/v1/Auth/get_file?hash=5f5b174c8ab6c732caffd82dfd54e72c50b5c686&mime_type=image/png"
								src_text={""}
								id={""}
								image_hash={""}
								mime_type={""}
								height="1rem"
								width="1rem"
							/>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge style={{ paddingLeft: "3px" }} size="md" type={pillType} color="pink" icon={false}>
							<Avatar
								size="custom"
								src="https://dev.connect.payzli.com/api/v1/Auth/get_file?hash=5f5b174c8ab6c732caffd82dfd54e72c50b5c686&mime_type=image/png"
								src_text={""}
								id={""}
								image_hash={""}
								mime_type={""}
								height="1rem"
								width="1rem"
							/>
							Label
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge style={{ paddingLeft: "3px" }} size="md" type={pillType} color="orange" icon={false}>
							<Avatar
								size="custom"
								src="https://dev.connect.payzli.com/api/v1/Auth/get_file?hash=5f5b174c8ab6c732caffd82dfd54e72c50b5c686&mime_type=image/png"
								src_text={""}
								id={""}
								image_hash={""}
								mime_type={""}
								height="1rem"
								width="1rem"
							/>
							Label
						</Badge>
					</div>
				</div>
				<div className="d-flex flex-direction-column gap1">
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="grey" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="sm" type={pillType} color="grey" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="md" type={pillType} color="grey" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="lg" type={pillType} color="grey" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="brand" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="sm" type={pillType} color="brand" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="md" type={pillType} color="brand" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="lg" type={pillType} color="brand" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="error" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="sm" type={pillType} color="error" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="md" type={pillType} color="error" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="lg" type={pillType} color="error" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="warning" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="sm" type={pillType} color="warning" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="md" type={pillType} color="warning" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="lg" type={pillType} color="warning" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="success" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="sm" type={pillType} color="success" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="md" type={pillType} color="success" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="lg" type={pillType} color="success" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="grey_blue" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="sm" type={pillType} color="grey_blue" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="md" type={pillType} color="grey_blue" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="lg" type={pillType} color="grey_blue" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="blue_light" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="sm" type={pillType} color="blue_light" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="md" type={pillType} color="blue_light" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="lg" type={pillType} color="blue_light" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="blue" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="sm" type={pillType} color="blue" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="md" type={pillType} color="blue" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="lg" type={pillType} color="blue" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="purple" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="sm" type={pillType} color="purple" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="md" type={pillType} color="purple" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="lg" type={pillType} color="purple" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="indigo" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="sm" type={pillType} color="indigo" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="md" type={pillType} color="indigo" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="lg" type={pillType} color="indigo" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="pink" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="sm" type={pillType} color="pink" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="md" type={pillType} color="pink" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="lg" type={pillType} color="pink" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
					</div>
					<div className="d-flex align-items-center gap2">
						<Badge size="xs" type={pillType} color="orange" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="sm" type={pillType} color="orange" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="md" type={pillType} color="orange" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
						<Badge size="lg" type={pillType} color="orange" icon={"icon-only"}>
							<Plus size={"0.75rem"} weight="bold" />
						</Badge>
					</div>
				</div>
			</div>
		</Section>
	);
};
export default AvatarSection;
